import {MainStore} from './models/MainStore';



export const store = new MainStore();

// @ts-ignore
window.store = store;
